import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { JobsService } from 'core/services/jobs.service';
import { ModalComponent } from 'core/components/modal/modal.component';
import { ToastService } from '../../core/services/toast.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-reporting-tool',
  templateUrl: './reporting-tool.component.html',
  styleUrls: ['./reporting-tool.component.scss']
})
export class ReportingToolComponent implements OnInit, OnDestroy {
  @ViewChild('modalConfigReports', { static: false }) public modalConfigReports: ModalComponent;
  public report: string;
  public personalization: any;
  public isBreakDownReport: boolean = false;
  public showBreakDownReport: boolean = false;
  public filters: any = {};
  public reportType: string;
  private reportingSubscription: Subscription;

  constructor(
    public route: ActivatedRoute,
    public jobsService: JobsService,
    public toastService: ToastService,
    public titleService: Title,
    public translate: TranslateService
  ) {}

  public ngOnInit(): void {
    this.reportingSubscription = this.route.data.subscribe((routeData) => {
      const queryParams = {
        ...this.route.snapshot.queryParams
      };
      this.reportType = ['assessment', 'applicability', 'selfassessment'].includes(routeData.personalization?.type)
        ? routeData.personalization?.type
        : queryParams.reportType || '';
      this.filters = queryParams.clientId ? { clientId: queryParams.clientId } : {};
      this.report = routeData.report;
      this.showBreakDownReport = routeData.personalization?.type === 'licensesBreakdown';
      this.isBreakDownReport = this.showBreakDownReport;
      this.personalization = routeData.personalization;
    });
    this.setReportTitle(this.report);
  }

  private setReportTitle(report) {
    const label = 'reports.' + report + '.label';
    this.titleService.setTitle(this.translate.instant(label));
  }

  public ngOnDestroy(): void {
    this.reportingSubscription.unsubscribe();
  }

  // microfrontend gl-reports

  public changeReportType(option: boolean): void {
    this.showBreakDownReport = option;
    this.modalConfigReports.close();
  }

  saveReport(event) {
    this.personalization = event.detail.report;
    this.toastService.showOk('', 3000, false);
  }

  downloadReport(event) {
    if (event) {
      this.manageDownloadJob(event.detail.job.id);
    }
  }

  async manageDownloadJob(jobId) {
    this.jobsService.manageJob(jobId, this.jobsService.jobTypes.DOWNLOAD_REPORT);
  }
}
